import React from 'react'
import Wrapper from './style'

const SchButton = ({onClick, type, disabled, children}) => {
	return (
		<Wrapper
			onClick={onClick}
			type={type}
			disabled={disabled}
		>
			{children}
		</Wrapper>
	)
}

export default SchButton